import { render, staticRenderFns } from "./AddUserAudiogramDialog.vue?vue&type=template&id=22283250&scoped=true"
import script from "./AddUserAudiogramDialog.vue?vue&type=script&lang=js"
export * from "./AddUserAudiogramDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22283250",
  null
  
)

export default component.exports